export const GET_ACTIONS = 'GET_ACTIONS'
export const SET_ACTIONS = 'SET_ACTIONS'
export const GET_ACTIONS_ERROR = 'GET_ACTIONS_ERROR'
export const RESET_ACTIONS = 'RESET_ACTIONS'
